export type IPlatform =
  | 'Windows'
  | 'Mac'
  | 'Android'
  | 'IOS'
  | 'Harmony_app'
  | 'Outlook'
  | 'Amd64'
  | 'Arm64'
  | 'Mips'
  | 'Loongarch64'
  | 'Amd64_kylin'
  | 'Arm64_kylin'
  | 'Mips_kylin'
  | 'Mips_sp1'
  | 'Loongarch64_kylin';
export type ILinuxPlatform = 'Amd64' | 'Arm64' | 'Mips' | 'Loongarch64' | 'Amd64_kylin' | 'Arm64_kylin' | 'Mips_kylin' | 'Mips_sp1' | 'Loongarch64_kylin';
export type IDesc = 'Outlook' | 'userGuide';
export const IMG_PATH = 'https://sdk-source.xylink.com/website/assets/download/';
export const linuxGuideUrl =
  'https://sdk-source.xylink.com/website/assets/download/%E5%B0%8F%E9%B1%BC%E6%98%93%E8%BF%9E%E4%BF%A1%E5%88%9B%E5%AE%A2%E6%88%B7%E7%AB%AF%E5%BF%AB%E9%80%9F%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97.pdf';

export interface IPlatformInfo {
  key: string;
  platform: string;
  versionName?: string;
  target?: string;
  appUrl?: string;
  guideUrl: string;
  guideUrl2?: string;
  title?: string;
  desc1?: string;
  desc2?: string;
  id?: string;
  downloadCountLabel?: string;
  statisticsSearchLabel?: string;
}
export const linuxPlatform = [
  {
    key: 'Amd64',
    platform: 'desktop_amd64',
    versionName: '',
    appUrl: '',
    downloadCountLabel: 'X86+统信UOS下载量',
    statisticsSearchLabel: 'AMD64_DOWNLOAD',
    guideUrl: linuxGuideUrl,
  },
  {
    key: 'Arm64',
    platform: 'desktop_arm64',
    versionName: '',
    appUrl: '',
    downloadCountLabel: 'arm+统信UOS下载量',
    statisticsSearchLabel: 'ARM64_DOWNLOAD',
    guideUrl: linuxGuideUrl,
  },
  // {
  //   key: 'Mips',
  //   platform: 'desktop_mips',
  //   versionName: '',
  //   appUrl: '',
  //   downloadCountLabel: 'mips+统信UOS下载量',
  //   statisticsSearchLabel: 'MIPS_DOWNLOAD',
  //   guideUrl: '',
  // },
  // {
  //   key: 'Loongarch64',
  //   platform: 'desktop_loongarch64',
  //   versionName: '',
  //   appUrl: '',
  //   downloadCountLabel: 'loongarch+统信UOS下载量',
  //   statisticsSearchLabel: 'LOONGARCH64_DOWNLOAD',
  //   guideUrl: '',
  // },
  {
    key: 'Amd64_kylin',
    platform: 'desktop_amd64_kylin',
    versionName: '',
    appUrl: '',
    downloadCountLabel: 'X86+麒麟V10/V10SP1下载量',
    statisticsSearchLabel: 'AMD64_KYLIN_DOWNLOAD',
    guideUrl: linuxGuideUrl,
  },
  {
    key: 'Arm64_kylin',
    platform: 'desktop_arm64_kylin',
    versionName: '',
    appUrl: '',
    downloadCountLabel: 'arm+麒麟V10/V10SP1下载量',
    statisticsSearchLabel: 'ARM64_KYLIN_DOWNLOAD',
    guideUrl: linuxGuideUrl,
  },
  // {
  //   key: 'Mips_kylin',
  //   platform: 'desktop_mips_kylin',
  //   versionName: '',
  //   appUrl: '',
  //   downloadCountLabel: 'mips+麒麟V10下载量',
  //   statisticsSearchLabel: 'MIPS_KYLIN_DOWNLOAD',
  //   guideUrl: '',
  // },
  // {
  //   key: 'Mips_sp1',
  //   platform: 'desktop_mips_sp1',
  //   versionName: '',
  //   appUrl: '',
  //   downloadCountLabel: 'mips+麒麟V10SP1下载量',
  //   statisticsSearchLabel: 'MIPS_SP1_DOWNLOAD',
  //   guideUrl: '',
  // },
  // {
  //   key: 'Loongarch64_kylin',
  //   platform: 'desktop_loongarch64_kylin',
  //   versionName: '',
  //   appUrl: '',
  //   downloadCountLabel: 'loongarch+麒麟V10/V10SP1下载量',
  //   statisticsSearchLabel: 'LOONGARCH64_KYLIN_DOWNLOAD',
  //   guideUrl: '',
  // },
];

export const platforms: (IPlatformInfo | IPlatformInfo[])[] = [
  {
    key: 'Windows',
    platform: 'desktop_pc',
    versionName: '',
    appUrl: '',
    downloadCountLabel: 'Windows下载量',
    statisticsSearchLabel: 'WINDOWS_DOWNLOAD',
    guideUrl: 'https://sdk-source.xylink.com/website/assets/download/%E5%B0%8F%E9%B1%BC%E6%98%93%E8%BF%9EWindows%E5%AE%A2%E6%88%B7%E7%AB%AF%E5%BF%AB%E9%80%9F%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97.pdf',
  },
  {
    key: 'Mac',
    platform: 'desktop_mac',
    versionName: '',
    appUrl: '',
    downloadCountLabel: 'Mac下载量',
    statisticsSearchLabel: 'MAC_DOWNLOAD',
    guideUrl: 'https://devcdn.xylink.com/xylink_website_doc/website_video/%E5%B0%8F%E9%B1%BC%E6%98%93%E8%BF%9EMac%E5%AE%A2%E6%88%B7%E7%AB%AF%E5%BF%AB%E9%80%9F%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97.pdf',
  },
  //信创包
  linuxPlatform,
  {
    id: 'iosAnchor',
    key: 'IOS',
    platform: 'ios_office',
    versionName: '',
    downloadCountLabel: 'iOS下载量',
    statisticsSearchLabel: 'IOS_DOWNLOAD',
    target: '_blank',
    appUrl: 'https://itunes.apple.com/cn/app/%E5%B0%8F%E9%B1%BC%E6%98%93%E8%BF%9Exylink/id1058254032?mt=9',
    guideUrl: 'https://sdk-source.xylink.com/website/assets/download/%E5%B0%8F%E9%B1%BC%E6%98%93%E8%BF%9EApp%E5%BF%AB%E9%80%9F%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97.pdf',
  },
  {
    id: 'androidAnchor',
    key: 'Android',
    platform: 'android',
    versionName: '',
    appUrl: '',
    downloadCountLabel: 'Android下载量',
    statisticsSearchLabel: 'ANDROID_DOWNLOAD',
    guideUrl: 'https://sdk-source.xylink.com/website/assets/download/%E5%B0%8F%E9%B1%BC%E6%98%93%E8%BF%9EApp%E5%BF%AB%E9%80%9F%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97.pdf',
  },
  {
    key: 'Harmony_app',
    platform: 'harmony_app',
    versionName: '',
    downloadCountLabel: '鸿蒙App下载量',
    statisticsSearchLabel: 'HARMONY_APP_DOWNLOAD',
    target: '_blank',
    appUrl: 'https://appgallery.huawei.com/app/detail?id=com.xylink.video.conference',
    guideUrl:
      'https://sdk-source.xylink.com/website/assets/download/%E5%B0%8F%E9%B1%BC%E6%98%93%E8%BF%9EApp%E5%BF%AB%E9%80%9F%E4%BD%BF%E7%94%A8%E6%8C%87%E5%8D%97%EF%BC%88%E9%B8%BF%E8%92%99%EF%BC%89.pdf',
  },
  {
    key: 'Outlook',
    platform: 'desktop_pc_outlook',
    versionName: '',
    appUrl: '',
    downloadCountLabel: 'Outlook插件下载量',
    guideUrl: '',
    title: 'Microsoft Outlook插件',
  },
  {
    id: 'frameworkAnchor',
    key: 'userGuide',
    platform: 'userGuide',
    guideUrl: 'https://devcdn.xylink.com/xylink_website_doc/XYLink%20Video%20Conferencing%20PC%20Client%20User%20Guide%281%29.pdf',
    guideUrl2: 'https://devcdn.xylink.com/xylink_website_doc/XYLink%20Video%20Conferencing%20App%20User%20Guide.pdf',
  },
  // 现暂时隐藏
  // {
  //   key: 'AndroidEdu',
  //   platform: 'android_edu',
  //   versionName: '',
  //   downloadCountLabel: '小鱼云课堂下载量',
  //   statisticsSearchLabel: 'ANDROID_EDU_DOWNLOAD',
  //   appUrl: '',
  //   guideUrl: 'https://testdevcdn.xylink.com/h5/sdk_doc/static/website/a8261a1002eabfd7cdb0ef975c7a908acf798c32df4b3398bfb73522a8b054ba.pdf',
  //   title: '小鱼云课堂',
  //   desc1: '小鱼云课堂Android APP，是为进行课程管理、手机巡课、教学资源点播学习、',
  //   desc2: '统计数据管理，而专门开发的教育应用。',
  // },
];

export interface IEduPlatformInfo {
  key: string;
  platform: string;
  btnText: string;
  appUrl: string;
  target?: string;
  id?: string;
}

export const eduPlatforms: IEduPlatformInfo[] = [
  {
    key: 'Windows',
    platform: 'desktop_pc',
    btnText: 'Windows客户端下载',
    appUrl: '',
  },
  {
    key: 'Mac',
    platform: 'desktop_mac',
    btnText: 'Mac客户端下载',
    appUrl: '',
  },
  {
    key: 'Null',
    platform: '',
    btnText: '',
    appUrl: '',
  },
  {
    id: 'androidAnchor',
    key: 'Android',
    platform: 'android',
    btnText: 'Android客户端下载',
    appUrl: '',
  },
  {
    id: 'iosAnchor',
    key: 'IOS',
    platform: 'ios_office',
    btnText: 'iOS客户端下载',
    appUrl: 'https://itunes.apple.com/cn/app/%E5%B0%8F%E9%B1%BC%E6%98%93%E8%BF%9Exylink/id1058254032?mt=9',
    target: '_blank',
  },
  {
    key: 'Assistant',
    platform: 'desktop_assistant',
    btnText: '易享课堂控制软件',
    appUrl: '',
  },
  {
    key: 'RecordReference',
    platform: 'tools',
    btnText: '精品录播实施参考',
    appUrl: 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/edu/129e1a0a4403a3108198e3dfc3c1ff1d9dfb61bfd5e23fd51f4e78f253191d36.zip',
  },
  {
    key: 'ClassReference',
    platform: 'tools',
    btnText: '专递课堂实施参考',
    appUrl: 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/eduDownload/12474306f8e32950110df7c4d28b036bcd63ff6fdbfa986cf18817263831a1e8.zip',
  },
  {
    key: 'Tools',
    platform: 'tools',
    btnText: '摄像头-配置工具及升级包',
    appUrl: 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/edu/e7f424ce708c81e1ab11d35abafef4e73ab3c223c2817a773ec8711c680f0d49.zip',
  },
  {
    key: 'AudioTool',
    platform: 'tools',
    btnText: '音频处理器配置工具',
    appUrl: 'https://sdk-source.xylink.com/h5/sdk_doc/static/website/edu/6a4420e4ce9329e046d47abee4c50214277a0d2a14b33eb949969a04bad8acbe.zip',
  },
];
